import { CookingDataResponse, CalculationDataRequest, CalculationDataResponse } from '@/entity/api-response'
import 'whatwg-fetch'

export class Api {
  private request = async <T>(type: 'POST' | 'GET', url: string, body?: any): Promise<T | 'error'> => {
    const urlencoded = new URLSearchParams()
    for (const key in body) {
      if (Object.prototype.hasOwnProperty.call(body, key)) {
        urlencoded.append(key, body[key])
      }
    }

    if (process.env.VUE_APP_ENV === 'local') console.log('[API REQUEST]' + url, body)

    return fetch(url, body !== undefined ? {
      method: type,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      body: urlencoded
    } : {
      method: type
    })
      .then((response : any) => {
        return response.json()
      })
      .then((response : T) => {
        if (process.env.VUE_APP_ENV === 'local') console.log('[API RESPONSE]' + url, response)
        return response
      })
      .catch((error : Error) => {
        if (process.env.VUE_APP_ENV === 'local') console.log('[API ERROR]' + url, error)
        return 'error'
      })
  }

  private get = <T>(url: string): Promise<T | 'error'> => {
    return this.request('GET', url)
  }

  private post = <T>(url: string, body?: any): Promise<T | 'error'> => {
    return this.request('POST', url, body)
  }

  async getCookingData (): Promise<CookingDataResponse | 'error'> {
    const res = await this.get<CookingDataResponse | 'error'>(process.env.VUE_APP_GET_URL)
    if (res === 'error') {
      return 'error'
    } else {
      return res
    }
  }

  async requestCalculation (data: CalculationDataRequest): Promise<CalculationDataResponse | 'error'> {
    const res = await (
      process.env.VUE_APP_ENV === 'serverless'
        ? this.get<CalculationDataResponse | 'error'>(process.env.VUE_APP_CALCULATION_URL)
        : this.post<CalculationDataResponse | 'error'>(process.env.VUE_APP_CALCULATION_URL, { data: JSON.stringify(data) })
    )
    if (res === 'error') {
      return 'error'
    } else {
      return res
    }
  }
}

export const api = new Api()
